module.exports = __webpack_public_path__ + "static/media/Aditya_khowal_resume.8c0de003.pdf";